// extracted by mini-css-extract-plugin
export var actionButton = "_8l-1";
export var actionButtons = "_8l-2";
export var actions = "_8l-0";
export var aiUnread = "_8l-10";
export var alignCenter = "_8l-h";
export var backWrapper = "_8l-3";
export var cellContainer = "_8l-4";
export var checkboxContainer = "_8l-5";
export var contentContainer = "_8l-6";
export var contentHeader = "_8l-8";
export var conversationsTableWrapper = "_8l-s";
export var draftReplyBadgeContainer = "_8l-m";
export var dropdownItem = "_8l-b";
export var dropdownItemsContainer = "_8l-a";
export var dropdownTitle = "_8l-c";
export var errorIcon = "_8l-7";
export var filter = "_8l-d";
export var gray = "_8l-i";
export var headerActionButtons = "_8l-e";
export var headerCheckboxContainer = "_8l-f";
export var icon = "_8l-j";
export var menuContainer = "_8l-k";
export var noMoreTicketsIcon = "_8l-12";
export var noMoreTicketsSubText = "_8l-13";
export var oneLine = "_8l-l";
export var optionsButton = "_8l-n";
export var plus = "_8l-o";
export var portalButtonsWrapper = "_8l-g";
export var red = "_8l-p";
export var scrolledTop = "_8l-9";
export var search = "_8l-q";
export var selectedConversationsCount = "_8l-r";
export var spinner = "_8l-t";
export var strong = "_8l-u";
export var summaryCell = "_8l-v";
export var tableContainer = "_8l-11";
export var tagContainer = "_8l-w";
export var threeDots = "_8l-x";
export var twoLines = "_8l-y";
export var unread = "_8l-z";